'use strict';

export default angular.module('contartemx.personal',[
    'ui.router'
])

.config(($stateProvider) => {

    $stateProvider.state('personal',{
            url: '/Personal',
            abstract:true,
            views:
            {
                'submenu':{
                    template: require('../../../../app/views/Personal/Personal_submenu.html'),
                    controller:'PersonalCtrl'
                },
                '':{
                    template: require('../../../../app/views/MainContainer.html'),
                    controller: 'PersonalCtrl'
                }
            },
            resolve: {
                authorize: ['authorization', authorization => authorization.authorize()],
                contartemxPersonal: ($q, $ocLazyLoad) => {
                    return import(
                  /* webpackChunkName: "personal" */
                  './personal'
                ).then(module => $ocLazyLoad.inject(module.default));
              }
            },
            data: { roles: ['Personal'] }
        }
    )
    .state('personal.nomina', {
            url: '/Nomina',
            views:
            {
                'main@personal':{
                    template: require('../../../../app/views/Personal/Nomina/Nomina_main.html'),
                    controller: 'PersNominaCtrl'
                }
            },
            data: { roles: ['Personal_Nomina'] }
        }
    )
    .state('personal.nomina.perfil_nomina', {
            url: '/:cvePer',
            views:
            {
                'main@personal':{
                    template: require('../../../../app/views/Personal/Nomina/PerfilNomina_main.html'),
                    controller: 'NominaPerfilCtrl'
                }
            },
            data: { roles: ['Personal_Nomina'] }
        }
    )
    .state('personal.directorio', {
            url: '/Directorio',
            views:
            {
                'main@personal':{
                    template: require('../../../../app/views/Personal/Directorio/Directorio_main.html'),
                    controller: 'PersDirectorioCtrl'
                }
            },
            data: { roles: ['Personal_Directorio'] }
        }
    )
    .state('personal.directorio.perfil_personal', {
            url: '/:cvePer',
            views:
            {
                'main@personal':{
                    template: require('../../../../app/views/Personal/Directorio/PerfilPersonal_main.html'),
                    controller: 'PersPerfilCtrl'
                }
            },
            data: { roles: ['Personal_Directorio'] }
        }
    )
    .state('personal.conceptos', {
            url: '/Conceptos',
            views:
            {
                'main@personal':{
                    template: require('../../../../app/views/Personal/Conceptos/Conceptos_main.html'),
                    controller: 'ConceptosCtrl'
                }
            },
            data: { roles: ['Personal_Conceptos'] }
        }
    )
    .state('personal.centros', {
            url: '/CentrosCostos/:cveTrans',
            views:
            {
                'main@personal':{
                    template: require('../../../../app/views/Personal/CentrosCostos/CentrosCostos_main.html'),
                    controller: 'CentrosCostosCtrl'
                }
            },
        }
    )
    .state('personal.pagos', {
            url: '/Pagos',
            views:
            {
                'main@personal':{
                    template: require('../../../../app/views/Personal/Pagos/Pagos_main.html'),
                    controller: 'PersPagosCtrl'
                }
            },
            data: { roles: ['Personal_Pago'] }
        }
    )
    .state('personal.pagos.nuevo_pago', {
            url: '/Nuevo/:cveTrans',
            views:
            {
                'main@personal':{
                    template: require('../../../../app/views/Personal/Pagos/NuevoPago_main.html'),
                    controller: 'PersNuevoPagoCtrl'
                }
            },
            data: { roles: ['Personal_Pago'] }
        }
    );
})

.controller('PersonalCtrl', ($scope, $state) => {

});

